import axios from 'axios';

const AxiosConfigure = {
  timeout: 180000,
  withCredentials: true,
  baseURL: process.env.REACT_APP_API_BASE_URL
};

export const axiosInstance = axios.create(AxiosConfigure);
axiosInstance.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axiosInstance.defaults.headers.common['Access-Control-Allow-Methods'] = 'DELETE, POST, GET, OPTIONS, PUT';
axiosInstance.defaults.headers.common['Access-Control-Allow-Headers'] = 'Content-Type, Authorization, X-Requested-With';
axiosInstance.defaults.withCredentials = true;
